import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  // Slider,
  withStyles,
  FormControlLabel,
  Checkbox,
  Hidden,
  useMediaQuery,
  useTheme,
  Divider,
} from "@material-ui/core";
import Slider from "@mui/material/Slider";
// import Skeleton from '@material-ui/lab/Skeleton';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import TitleText from "../../components/reusableComponents/TitleText";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import BodyText from "../../components/reusableComponents/BodyText";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import InfiniteScroll from "react-infinite-scroll-component";
import FlightDetailModal from "../../components/reusableComponents/FlightDetailModal";
import h1 from "../../assets/images/h1.png";
import h2 from "../../assets/images/h2.jpg";
import h3 from "../../assets/images/h3.png";
import h4 from "../../assets/images/h4.png";
import h5 from "../../assets/images/h5.png";
import flightrun from "../../assets/images/flightrun.png";
import { setFlightId, toggleFlightModal } from "../../reducers/UiReducer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import { useHistory, useLocation } from "react-router-dom";
import {
  AddSearchFlightDispatch,
  SearchEtravFormDispatch,
  SearchFormDispatch,
  searchSuccess,
  searchSuccessEtrav,
  SearchTripjackFormDispatch,
} from "../../reducers/HomeReducer";
import Drawers from "../../components/Drawers";
import Login from "../../components/reusableComponents/Login";
import OnewayForm from "../../form/OneWayFlightForm";
import {
  FlightFareRuleDispatch,
  FlightFareRuleEtravDispatch,
} from "../../reducers/HomeReducer";
import flightnotfound from "../../assets/images/flightnotfound.png";
import HeaderSection from "../../components/reusableComponents/HeaderSection";
import ErrorModal from "../../components/reusableComponents/ErrorModal";
import SkeletonOneway from "../../components/reusableComponents/SkeletonOneway";
import OneWayMobileRow from "../Mobile/OneWayMobileRow";
import Linear from "../../components/reusableComponents/Linear";
import OneWayDesktopRow from "../../components/reusableComponents/OneWayDesktopRow";
import SearchFlight from "../../form/SearchFlight";
import { flightSearchTripJackDispatch } from "../../reducers/TripjackReducer";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiChip-sizeSmall": {
      height: 36,
    },
  },
  accodin: {
    "& .MuiAccordionSummary-content": {
      justifyContent: "space-between",
    },
  },
  searhform: {
    // backgroundImage: `url(${Home})`,
    // height: 272,
    // backgroundSize: 'cover',
    // backgroundRepeat: 'no-repeat',

    paddingTop: 84,
    paddingBottom: 30,
	paddingLeft:20,
	paddingRight:20,
    backgroundColor: "midnightblue",
    [theme.breakpoints.down("md")]: {
      height: 508,
    },
    [theme.breakpoints.down("xs")]: {
      height: 590,
    },
  },
  radio: {
    "& .MuiTypography-body1": {
      fontSize: 13,
    },
  },
}));

const GreenCheckbox = withStyles({
  root: {
    color: "rgb(239, 51, 57)",
    "&$checked": {
      color: "rgb(239, 51, 57)",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
const OneWay = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState("");
  const [check, setCheck] = useState(false);
  const [stopcheck1, setStopCheck1] = useState(false);
  const [stopcheck2, setStopCheck2] = useState(false);
  const [stopcheck3, setStopCheck3] = useState(false);
  const [airlineS, setairlineS] = useState(false);
  const [airlineG, setairlineG] = useState(false);
  const [airlineI, setairlineI] = useState(false);
  const [airlineA, setairlineA] = useState(false);
  const [airlineV, setairlineV] = useState(false);
  const [morning, setMorning] = useState(false);
  const [refund, setRefund] = useState(false);
  const [nrefund, setNRefund] = useState(false);
  const [seg, setSeg] = useState(null);
  const [net, setNet] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [check4, setCheck4] = useState(false);
  const [check5, setCheck5] = useState(false);
  const [rule, SetRule] = useState(false);
  const [scrollVal, SetScrollVal] = useState(10);
  const [scrollValResult, SetScrollValResult] = useState(10);
  const [hasMoreresult, SethasMoreResult] = useState(true);
  const [hasMorefilterData, SethasMoreFilterData] = useState(true);
  const [result, setResult] = useState([]);
  const history = useHistory();
  const theme = useTheme();
  const location = useLocation();
  const [air, setAir] = useState(true);
  const [st, setSt] = useState(true);
  const [stp, setStp] = useState(true);
  const [out, setOut] = useState(true);
  const [rf, setRf] = useState(true);
  const [toggle, setToggle] = useState(false);
  const {
    search,
    loading,
    onewayflightdata,
    onewayflightdataEtrav,
    tripjack,
    holdflt,
  } = useSelector((state) => state.home);
  const { selectedOrigin, selectedDepart } = useSelector((state) => state.ui);
  const { agentlogin } = useSelector((state) => state.user);
  const [stop1, setStop1] = useState(false);
  const [value, setValue] = React.useState([1000, 100000]);

  const [stop2, setStop2] = useState(false);
  const [stop3, setStop3] = useState(false);
  const { AdultCount, ChildCount, InfantCount } = location.state.body;
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const matches2 = useMediaQuery(theme.breakpoints.down("xs"));
  const handleSlider = (event, newValue) => {
    setValue(newValue);
    // console.log(newValue);
    setResult([]);
    let combineflightData = [];
    let checkDataTBO = [];
    let checkDataEtrav = [];
    let filterCombineData = [];
    if (onewayflightdata && newValue) {
      onewayflightdata &&
        onewayflightdata.result &&
        onewayflightdata.result.Response &&
        onewayflightdata.result.Response.Results[0].length > 0 &&
        onewayflightdata.result.Response.Results[0].map((item) => {
          let a = item.Fare.Total_Amount;
          let b = newValue[0];
          let c = newValue[1];
          if (a >= b && a <= c) {
            checkDataTBO.push({
              ...item,
            });
          }
        });
    }
    if (onewayflightdataEtrav && newValue) {
      onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0] &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          let a = item.Fares.Total_Amount;
          let b = newValue[0];
          let c = newValue[1];
          if (a >= b && a <= c) {
            checkDataEtrav.push({
              ...item,
            });
          }
        });
    }
    combineflightData = [...checkDataTBO, ...checkDataEtrav];
    // console.log("checkData", combineflightData);
    filterCombineData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(Math.round(a.Fare.Total_Amount))
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : Number(Math.round(a.Fare.Total_Amount));
        let second = b.Fare
          ? Number(Math.round(b.Fare.Total_Amount))
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount));
        return first - second;
      });
    setResult(filterCombineData);
    // console.log("Filter", filterCombineData);
    SetScrollValResult(10);

    // console.log('Slider Value', checkData);
  };
  const handleNetFare = (event) => {
    setNet(event.target.checked);
    // console.log(event.target.name);
  };
  
  
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  function valuetext(value) {
    return `${value}°C`;
  }
  function hrToMin(a, b) {
    let hours = Math.trunc(a * 60);
    let minutes = b;
    return hours + minutes;
  }
  function convertH2M(timeInHour) {
    // console.log(timeInHour);
    var timeParts = timeInHour.split(":");
    return Number(timeParts[0]) * 60 + Number(timeParts[1]);
  }
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + " hr and " + rminutes + " min.";
  }
  // console.log(location.state);
  // console.log("CheckValue", check);
  // console.log("Check2Value", check2);
  // console.log("Rule", rule);
  let combineflightData = [];
  let demo = [];
  let filterData = [];
  let flt = [];
  if (loading) {
    console.log("Loading");
  } else {
    let tbo =
      onewayflightdata &&
      onewayflightdata?.result &&
      onewayflightdata?.result?.Response &&
      onewayflightdata?.result?.Response?.Results[0].length > 0 &&
      onewayflightdata?.result?.Response?.Results[0];
    let Etrav =
      onewayflightdataEtrav &&
      onewayflightdataEtrav?.result &&
      onewayflightdataEtrav?.result?.TripDetails &&
      onewayflightdataEtrav?.result?.TripDetails[0]?.Flights.length > 0 &&
      onewayflightdataEtrav?.result?.TripDetails[0]?.Flights;
    let tjk =
      tripjack &&
      tripjack?.result &&
      tripjack?.result?.searchResult &&
      tripjack?.result?.searchResult?.tripInfos &&
      tripjack?.result?.searchResult?.tripInfos?.ONWARD;
    if (Etrav?.length > 0 && tbo?.length > 0 && tjk?.length > 0) {
      combineflightData = [...tbo, ...Etrav, ...tjk];
    } else if (Etrav?.length > 0 && tbo?.length > 0) {
      combineflightData = [...tbo, ...Etrav];
    } else if (Etrav?.length > 0 && tjk?.length > 0) {
      combineflightData = [...Etrav, ...tjk];
    } else if (tbo?.length > 0 && tjk?.length > 0) {
      combineflightData = [...tbo, ...tjk];
    } else if (tbo?.length > 0) {
      combineflightData = [...tbo];
    } else if (tjk?.length > 0) {
      combineflightData = [...tjk];
    } else if (Etrav?.length > 0) {
      combineflightData = [...Etrav];
    }

    // console.log("combine", combineflightData);

    filterData =
      combineflightData &&
      combineflightData.length > 0 &&
      combineflightData.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            )
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : a.totalPriceList
          ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
          : Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            );
        let second = b.Fare
          ? Number(
              Number(Math.round(b.Fare.Total_Amount)) -
                Number(Math.round(b.Fare.MFB_Discount))
            )
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : b.totalPriceList
          ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount)) -
            Number(Math.round(b.Fare.MFB_Discount));
        return first - second;
      });
  
  }
  // console.log("FLT", flt);
  // console.log("TBO", combineflightData);
  // console.log("Demo", demo);
 

  // console.log("FilterData", filterData);

  const fetchMoreData = () => {
    if (scrollVal >= filterData.length) {
      SethasMoreFilterData(false);
    }

    setTimeout(() => {
      SetScrollVal(scrollVal + 5);
    }, 500);
  };
  const fetchMoreDataResult = () => {
    if (scrollValResult >= filterData.length) {
      SethasMoreResult(false);
    }
    setTimeout(() => {
      SetScrollValResult(scrollValResult + 5);
    }, 500);
  };

  useEffect(() => {
    if (location.state) {
      dispatch(SearchFormDispatch(location.state.body, history));
      dispatch(SearchEtravFormDispatch(location.state.body));
      dispatch(AddSearchFlightDispatch(location.state.body));
      dispatch(SearchTripjackFormDispatch(location.state.body));
      window.scrollTo(0, 0);
    }
  }, [dispatch]);

//  Filter Section Starting
const handleStop=(event)=>{
    setStopCheck1(event.target.checked);
  
  if(stopcheck1){
    setResult([])
    SetRule(event.target.checked);
  }else{
  SetRule(event.target.checked);
  console.log(event.target.name);
  let filterCombineStop = [];
  let filterDataStop = [];
  let tbo=[];
  let etrav=[];
  let tjk=[];
  if (onewayflightdata) {
    onewayflightdata &&
      onewayflightdata.result &&
      onewayflightdata.result.Response &&
      onewayflightdata.result.Response.Results[0].length > 0 &&
      onewayflightdata.result.Response.Results[0].map((item) => {
        if (item.Segments[0].length === 1) {
          tbo.push({
            ...item,
          });
        }
      });
  }
  if (onewayflightdataEtrav) {
    onewayflightdataEtrav &&
      onewayflightdataEtrav.result &&
      onewayflightdataEtrav.result.TripDetails[0] &&
      onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
      onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
        if (item.Segments.length === 1) {
          etrav.push({
            ...item,
          });
        }
      });
  }
  if (tripjack) {
    tripjack &&
      tripjack.result &&
      tripjack.result.searchResult &&
      tripjack.result.searchResult.tripInfos&&
      tripjack.result.searchResult.tripInfos.ONWARD&&
      tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
      tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
        if (item.sI.length === 1) {
          tjk.push({
            ...item,
          });
        }
      });
  }
  filterCombineStop = [...tbo,...etrav,...tjk];
  console.log("Combine",filterCombineStop)
  filterDataStop =
      filterCombineStop &&
      filterCombineStop.length > 0 &&
      filterCombineStop.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            )
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : a.totalPriceList
          ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
          : Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            );
        let second = b.Fare
          ? Number(
              Number(Math.round(b.Fare.Total_Amount)) -
                Number(Math.round(b.Fare.MFB_Discount))
            )
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : b.totalPriceList
          ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount)) -
            Number(Math.round(b.Fare.MFB_Discount));
        return first - second;
      });
  console.log("stop3", filterDataStop);
  setResult(filterDataStop);
}

}
const handleStop2=(event)=>{
    setStopCheck2(event.target.checked);
  
  if(stopcheck2){
    setResult([])
    SetRule(event.target.checked);
  }else{
  SetRule(event.target.checked);
  console.log(event.target.name);
  let filterCombineStop = [];
  let filterDataStop = [];
  let tbo=[];
  let etrav=[];
  let tjk=[];
  if (onewayflightdata) {
    onewayflightdata &&
      onewayflightdata.result &&
      onewayflightdata.result.Response &&
      onewayflightdata.result.Response.Results[0].length > 0 &&
      onewayflightdata.result.Response.Results[0].map((item) => {
        if (item.Segments[0].length === 2) {
          tbo.push({
            ...item,
          });
        }
      });
  }
  if (onewayflightdataEtrav) {
    onewayflightdataEtrav &&
      onewayflightdataEtrav.result &&
      onewayflightdataEtrav.result.TripDetails[0] &&
      onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
      onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
        if (item.Segments.length === 2) {
          etrav.push({
            ...item,
          });
        }
      });
  }
  if (tripjack) {
    tripjack &&
      tripjack.result &&
      tripjack.result.searchResult &&
      tripjack.result.searchResult.tripInfos&&
      tripjack.result.searchResult.tripInfos.ONWARD&&
      tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
      tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
        if (item.sI.length === 2) {
          tjk.push({
            ...item,
          });
        }
      });
  }
  filterCombineStop = [...tbo,...etrav,...tjk];
  // console.log("Combine",filterCombineStop)
  filterDataStop =
      filterCombineStop &&
      filterCombineStop.length > 0 &&
      filterCombineStop.slice().sort((a, b) => {
        let first = a.Fare
          ? Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            )
          : a.Fares
          ? Number(Math.round(a.Fares.Total_Amount))
          : a.totalPriceList
          ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
          : Number(
              Number(Math.round(a.Fare.Total_Amount)) -
                Number(Math.round(a.Fare.MFB_Discount))
            );
        let second = b.Fare
          ? Number(
              Number(Math.round(b.Fare.Total_Amount)) -
                Number(Math.round(b.Fare.MFB_Discount))
            )
          : b.Fares
          ? Number(Math.round(b.Fares.Total_Amount))
          : b.totalPriceList
          ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
          : Number(Math.round(b.Fare.Total_Amount)) -
            Number(Math.round(b.Fare.MFB_Discount));
        return first - second;
      });
  // console.log("stop3", filterDataStop);
  setResult(filterDataStop);
}

}
const handleStop3=(event)=>{
  setStopCheck3(event.target.checked);

if(stopcheck3){
  setResult([])
  SetRule(event.target.checked);
}else{
SetRule(event.target.checked);
console.log(event.target.name);
let filterCombineStop = [];
let filterDataStop = [];
let tbo=[];
let etrav=[];
let tjk=[];
if (onewayflightdata) {
  onewayflightdata &&
    onewayflightdata.result &&
    onewayflightdata.result.Response &&
    onewayflightdata.result.Response.Results[0].length > 0 &&
    onewayflightdata.result.Response.Results[0].map((item) => {
      if (item.Segments[0].length === 3) {
        tbo.push({
          ...item,
        });
      }
    });
}
if (onewayflightdataEtrav) {
  onewayflightdataEtrav &&
    onewayflightdataEtrav.result &&
    onewayflightdataEtrav.result.TripDetails[0] &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
      if (item.Segments.length === 3) {
        etrav.push({
          ...item,
        });
      }
    });
}
if (tripjack) {
  tripjack &&
    tripjack.result &&
    tripjack.result.searchResult &&
    tripjack.result.searchResult.tripInfos&&
    tripjack.result.searchResult.tripInfos.ONWARD&&
    tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
    tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
      if (item.sI.length === 3) {
        tjk.push({
          ...item,
        });
      }
    });
}
filterCombineStop = [...tbo,...etrav,...tjk];
// console.log("Combine",filterCombineStop)
filterDataStop =
    filterCombineStop &&
    filterCombineStop.length > 0 &&
    filterCombineStop.slice().sort((a, b) => {
      let first = a.Fare
        ? Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          )
        : a.Fares
        ? Number(Math.round(a.Fares.Total_Amount))
        : a.totalPriceList
        ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
        : Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          );
      let second = b.Fare
        ? Number(
            Number(Math.round(b.Fare.Total_Amount)) -
              Number(Math.round(b.Fare.MFB_Discount))
          )
        : b.Fares
        ? Number(Math.round(b.Fares.Total_Amount))
        : b.totalPriceList
        ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
        : Number(Math.round(b.Fare.Total_Amount)) -
          Number(Math.round(b.Fare.MFB_Discount));
      return first - second;
    });
// console.log("stop3", filterDataStop);
setResult(filterDataStop);
}

}
const handleAirline=(event)=>{
  if(event.target.name==='SG'){
    setairlineS(event.target.checked);
  }else if(event.target.name==='G8'){
    setairlineG(event.target.checked);
  }else if(event.target.name==='6E'){
    setairlineI(event.target.checked);
  }else if(event.target.name==='I5'){
    setairlineA(event.target.checked);
  }else if(event.target.name==='UK'){
    setairlineV(event.target.checked);
  }
  

if(airlineA||airlineG||airlineI||airlineS||airlineV){
  setResult([])
  SetRule(event.target.checked);
}else{
SetRule(event.target.checked);
console.log(event.target.name);
let filterCombineStop = [];
let filterDataStop = [];
let tbo=[];
let etrav=[];
let tjk=[];
if (onewayflightdata) {
  onewayflightdata &&
  onewayflightdata &&
  onewayflightdata.result &&
  onewayflightdata.result.Response &&
  onewayflightdata.result.Response.Results[0].length > 0 &&
  onewayflightdata.result.Response.Results[0].map((item) => {
    if (item.AirlineCode === event.target.name) {
      tbo.push({
        ...item,
      });
    }
  });
}
if (onewayflightdataEtrav) {
  onewayflightdataEtrav &&
        onewayflightdataEtrav.result &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
        onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
          if (item.Airline_Code === event.target.name) {
            etrav.push({
              ...item,
            });
          }
        });
}
if (tripjack) {
  tripjack &&
    tripjack.result &&
    tripjack.result.searchResult &&
    tripjack.result.searchResult.tripInfos&&
    tripjack.result.searchResult.tripInfos.ONWARD&&
    tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
    tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
      if (item.sI[0].fD.aI.code === event.target.name) {
        tjk.push({
          ...item,
        });
      }
    });
}
filterCombineStop = [...tbo,...etrav,...tjk];
console.log("Combine",filterCombineStop)
filterDataStop =
    filterCombineStop &&
    filterCombineStop.length > 0 &&
    filterCombineStop.slice().sort((a, b) => {
      let first = a.Fare
        ? Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          )
        : a.Fares
        ? Number(Math.round(a.Fares.Total_Amount))
        : a.totalPriceList
        ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
        : Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          );
      let second = b.Fare
        ? Number(
            Number(Math.round(b.Fare.Total_Amount)) -
              Number(Math.round(b.Fare.MFB_Discount))
          )
        : b.Fares
        ? Number(Math.round(b.Fares.Total_Amount))
        : b.totalPriceList
        ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
        : Number(Math.round(b.Fare.Total_Amount)) -
          Number(Math.round(b.Fare.MFB_Discount));
      return first - second;
    });
console.log("filterAilrine", filterDataStop);
setResult(filterDataStop);
}

}
const handleMorning=(event)=>{
  setMorning(event.target.checked);

if(morning){
  setResult([])
  SetRule(event.target.checked);
}else{
SetRule(event.target.checked);
let filterCombineStop = [];
let filterDataStop = [];
let tbo=[];
let etrav=[];
let tjk=[];
if (onewayflightdata) {
  onewayflightdata &&
  onewayflightdata.result &&
  onewayflightdata.result.Response &&
  onewayflightdata.result.Response.Results[0].length > 0 &&
  onewayflightdata.result.Response.Results[0].map((item) => {
    console.log(
      item.Segments[0].slice(0, 1).map((i) => {
        return i.Origin.DepTime.substr(11, 2);
      })
    );
    console.log(
      "Dept",
      item.Segments[0].slice(0, 1).map((i) => {
        return i.Destination.ArrTime.substr(11, 2);
      })
    );
    let a = item.Segments[0].slice(0, 1).map((i) => {
      return i.Origin.DepTime.substr(11, 2);
    });
    let b = item.Segments[0].slice(0, 1).map((i) => {
      return i.Destination.ArrTime.substr(11, 2);
    });
    if (a >= 4 && b <= 12) {
      tbo.push({
        ...item,
      });
    }
  });
}
// if (onewayflightdataEtrav) {
//   onewayflightdataEtrav &&
//     onewayflightdataEtrav.result &&
//     onewayflightdataEtrav.result.TripDetails[0] &&
//     onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
//     onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
//       if (item.Segments.length === 1) {
//         etrav.push({
//           ...item,
//         });
//       }
//     });
// }
// if (tripjack) {
//   tripjack &&
//     tripjack.result &&
//     tripjack.result.searchResult &&
//     tripjack.result.searchResult.tripInfos&&
//     tripjack.result.searchResult.tripInfos.ONWARD&&
//     tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
//     tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
//       if (item.sI.length === 1) {
//         tjk.push({
//           ...item,
//         });
//       }
//     });
// }
filterCombineStop = [...tbo];
console.log("Combine",filterCombineStop)
filterDataStop =
    filterCombineStop &&
    filterCombineStop.length > 0 &&
    filterCombineStop.slice().sort((a, b) => {
      let first = a.Fare
        ? Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          )
        : a.Fares
        ? Number(Math.round(a.Fares.Total_Amount))
        : a.totalPriceList
        ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
        : Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          );
      let second = b.Fare
        ? Number(
            Number(Math.round(b.Fare.Total_Amount)) -
              Number(Math.round(b.Fare.MFB_Discount))
          )
        : b.Fares
        ? Number(Math.round(b.Fares.Total_Amount))
        : b.totalPriceList
        ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
        : Number(Math.round(b.Fare.Total_Amount)) -
          Number(Math.round(b.Fare.MFB_Discount));
      return first - second;
    });
console.log("stop3", filterDataStop);
setResult(filterDataStop);
}

}
const handleFareR=(event)=>{
  setRefund(event.target.checked);

if(refund){
  setResult([])
  SetRule(event.target.checked);
}else{
SetRule(event.target.checked);
let filterCombineStop = [];
let filterDataStop = [];
let tbo=[];
let etrav=[];
let tjk=[];
if (onewayflightdata) {
  onewayflightdata &&
    onewayflightdata.result &&
    onewayflightdata.result.Response &&
    onewayflightdata.result.Response.Results[0].length > 0 &&
    onewayflightdata.result.Response.Results[0].map((item) => {
      if (item.IsRefundable) {
        tbo.push({
          ...item,
        });
      }
    });
}
if (onewayflightdataEtrav) {
  onewayflightdataEtrav &&
    onewayflightdataEtrav.result &&
    onewayflightdataEtrav.result.TripDetails[0] &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
      if (item.Fares.Refundable) {
        etrav.push({
          ...item,
        });
      }
    });
}
if (tripjack) {
  tripjack &&
    tripjack.result &&
    tripjack.result.searchResult &&
    tripjack.result.searchResult.tripInfos&&
    tripjack.result.searchResult.tripInfos.ONWARD&&
    tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
    tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
      if (item.totalPriceList.fd.ADULT.rT === 1) {
        tjk.push({
          ...item,
        });
      }
    });
}
filterCombineStop = [...tbo,...etrav,...tjk];
console.log("Combine",filterCombineStop)
filterDataStop =
    filterCombineStop &&
    filterCombineStop.length > 0 &&
    filterCombineStop.slice().sort((a, b) => {
      let first = a.Fare
        ? Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          )
        : a.Fares
        ? Number(Math.round(a.Fares.Total_Amount))
        : a.totalPriceList
        ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
        : Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          );
      let second = b.Fare
        ? Number(
            Number(Math.round(b.Fare.Total_Amount)) -
              Number(Math.round(b.Fare.MFB_Discount))
          )
        : b.Fares
        ? Number(Math.round(b.Fares.Total_Amount))
        : b.totalPriceList
        ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
        : Number(Math.round(b.Fare.Total_Amount)) -
          Number(Math.round(b.Fare.MFB_Discount));
      return first - second;
    });
console.log("stop3", filterDataStop);
setResult(filterDataStop);
}

}
const handleFareN=(event)=>{
  setNRefund(event.target.checked);

if(nrefund){
  setResult([])
  SetRule(event.target.checked);
}else{
SetRule(event.target.checked);
let filterCombineStop = [];
let filterDataStop = [];
let tbo=[];
let etrav=[];
let tjk=[];
if (onewayflightdata) {
  onewayflightdata &&
    onewayflightdata.result &&
    onewayflightdata.result.Response &&
    onewayflightdata.result.Response.Results[0].length > 0 &&
    onewayflightdata.result.Response.Results[0].map((item) => {
      if (!item.IsRefundable) {
        tbo.push({
          ...item,
        });
      }
    });
}
if (onewayflightdataEtrav) {
  onewayflightdataEtrav &&
    onewayflightdataEtrav.result &&
    onewayflightdataEtrav.result.TripDetails[0] &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.length > 0 &&
    onewayflightdataEtrav.result.TripDetails[0].Flights.map((item) => {
      if (!item.Fares.Refundable) {
        etrav.push({
          ...item,
        });
      }
    });
}
if (tripjack) {
  tripjack &&
    tripjack.result &&
    tripjack.result.searchResult &&
    tripjack.result.searchResult.tripInfos&&
    tripjack.result.searchResult.tripInfos.ONWARD&&
    tripjack.result.searchResult.tripInfos.ONWARD.length > 0 &&
    tripjack.result.searchResult.tripInfos.ONWARD.map((item) => {
      if (item.totalPriceList.fd.ADULT.rT === 0) {
        tjk.push({
          ...item,
        });
      }
    });
}
filterCombineStop = [...tbo,...etrav,...tjk];
console.log("Combine",filterCombineStop)
filterDataStop =
    filterCombineStop &&
    filterCombineStop.length > 0 &&
    filterCombineStop.slice().sort((a, b) => {
      let first = a.Fare
        ? Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          )
        : a.Fares
        ? Number(Math.round(a.Fares.Total_Amount))
        : a.totalPriceList
        ? Number(Math.round(a.totalPriceList.fd.Total_Amount))
        : Number(
            Number(Math.round(a.Fare.Total_Amount)) -
              Number(Math.round(a.Fare.MFB_Discount))
          );
      let second = b.Fare
        ? Number(
            Number(Math.round(b.Fare.Total_Amount)) -
              Number(Math.round(b.Fare.MFB_Discount))
          )
        : b.Fares
        ? Number(Math.round(b.Fares.Total_Amount))
        : b.totalPriceList
        ? Number(Math.round(b.totalPriceList.fd.Total_Amount))
        : Number(Math.round(b.Fare.Total_Amount)) -
          Number(Math.round(b.Fare.MFB_Discount));
      return first - second;
    });
console.log("stop3", filterDataStop);
setResult(filterDataStop);
}

}
// Filter Section Ending
  // console.log("ResultPart", result);
  console.log("stop1", stopcheck1);
  console.log("stop2", seg);
  return (
    <>
      {/* Header Starting */}
      <HeaderSection id={1} />
      {/* Header Ending */}

      {/* Oneway Form Starting */}
      {filterData?.length ? (
        <Box
          styel={{
            visibility: true ? "hidden" : "visible",
            opacity: true ? 0 : 1,
            transition: true
              ? ""
              : "visibility 0s linear 0.33s, opacity 0.33s linear",
            transitionDelay: true ? "" : "0s",
			// paddingLeft:20,
			// paddingRight:20
          }}
          className={classes.searhform}
        >
          {/* <Container> */}
            <OnewayForm />
            {/* <SearchFlight /> */}
          {/* </Container> */}
        </Box>
      ) : (
        <Linear />
      )}
      {/* Oneway Form Ending */}
      <Box style={{ padding: matches ? 10 : 20, background: "#e5eef4" }}>
        <Box>
          {/* <Container> */}
          <Box style={{ padding: matches ? 10 : 20 }}>
            {filterData?.length ? (
              // <Skeleton variant='rectangular' width='100%' height={118} />
              <></>
            ) : (
              <marquee direction="right">
                <img
                  src={flightrun}
                  style={{ width: 100, height: 32, marginTop: 10 }}
                />
              </marquee>
            )}

            <Grid container style={{ marginTop: 20 }} spacing={2}>
              <Grid item xs={12} lg={3}>
                <Box
                  style={{
                    padding: 15,
                    boxShadow: "0 3px 30px 0 rgb(0 0 0 / 10%)",
                    background: "white",
                    borderRadius: 5,
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box display="flex" alignItems="center">
                      <i
                        class="fa fa-search"
                        style={{ margin: 6, fontSize: 20 }}
                      ></i>
                      <span style={{ fontSize: 15 }}>Filter</span>
                    </Box>
                    <p style={{ fontSize: 13 }}>
                      <u>Clear all filters</u>
                    </p>
                  </Box>

                  {/* <Divider /> */}
                  {/* <Box style={{background:'#E0DEDE',padding:5}}>
					<b style={{fontWeight:'bold'}}>  <span class="air_down_icon" id="icon_dept" style={{fontSize:14}}>▼</span> Outbound Flight Times:</b>
               

				</Box> */}
                  <Box
                    style={{
                      background: "#E0DEDE",
                      padding: 5,
                      cursor: "pointer",
                      marginTop: 20,
                    }}
                    onClick={() => (stp ? setStp(false) : setStp(true))}
                  >
                    <b style={{ fontWeight: "bold" }}>
                      {" "}
                      <span
                        class="air_down_icon"
                        id="icon_dept"
                        style={{ fontSize: 14 }}
                      >
                        ▼
                      </span>
                      Stops:
                    </b>
                  </Box>
                  {stp ? (
                    <>
                      {" "}
                      <Box
                        mt={matches ? "20px" : ""}
                        className={classes.radio}
                        style={{
                          border: "1px solid lightgrey",
                          padding: "10px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={stopcheck1}
                              onChange={handleStop}
                              name="1"
                            />
                          }
                          label="Direct"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={stopcheck2}
                              onChange={handleStop2}
                              name="2"
                            />
                          }
                          label="1"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={stopcheck3}
                              onChange={handleStop3}
                              name="3"
                            />
                          }
                          label="2 & more"
                        />
                      </Box>
                    </>
                  ) : (
                    ""
                  )}

                  {/* <Divider style={{ marginTop: 20 }} /> */}

                  <Divider style={{ marginTop: 20 }} />
                  <Box
                    style={{
                      background: "#E0DEDE",
                      padding: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => (air ? setAir(false) : setAir(true))}
                  >
                    <b style={{ fontWeight: "bold" }}>
                      {" "}
                      <span
                        class="air_down_icon"
                        id="icon_dept"
                        style={{ fontSize: 14 }}
                      >
                        ▼
                      </span>
                      Airlines:
                    </b>
                  </Box>
                  {air ? (
                    <>
                      {" "}
                      <Box
                        mt={matches ? "20px" : ""}
                        className={classes.radio}
                        style={{
                          border: "1px solid lightgrey",
                          padding: "10px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={airlineS}
                              onChange={handleAirline}
                              name="SG"
                            />
                          }
                          label="SpiceJet"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={airlineG}
                              onChange={handleAirline}
                              name="G8"
                            />
                          }
                          label="GO FIRST"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={airlineI}
                              onChange={handleAirline}
                              name="6E"
                            />
                          }
                          label="Indigo"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={airlineA}
                              onChange={handleAirline}
                              name="I5"
                            />
                          }
                          label="Air Asia"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={airlineV}
                              onChange={handleAirline}
                              name="UK"
                            />
                          }
                          label="Vistara"
                        />
                        <br />
                      </Box>
                    </>
                  ) : (
                    ""
                  )}

                  <Divider style={{ marginTop: 20 }} />
                  <Box
                    style={{
                      background: "#E0DEDE",
                      padding: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => (out ? setOut(false) : setOut(true))}
                  >
                    <b style={{ fontWeight: "bold" }}>
                      {" "}
                      <span
                        class="air_down_icon"
                        id="icon_dept"
                        style={{ fontSize: 14 }}
                      >
                        ▼
                      </span>
                      Outbound Flight Times:
                    </b>
                  </Box>
                  {out ? (
                    <>
                      {" "}
                      <Box
                        mt={matches ? "20px" : ""}
                        className={classes.radio}
                        style={{
                          border: "1px solid lightgrey",
                          padding: "10px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={morning}
                              onChange={handleMorning}
                              name="Morning"
                            />
                          }
                          label="Morning(04:00-11:00)"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={check2}
                              // onChange={handleCheckGO}
                              name="G8"
                            />
                          }
                          label="Afternoon(11:00-16:00)"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={check3}
                              // onChange={handleCheckIndigo}
                              name="6E"
                            />
                          }
                          label="Evening(16:00-21:00)"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={check4}
                              // onChange={handleCheckAir}
                              name="I5"
                            />
                          }
                          label="Night(21:00-04:00)"
                        />
                        
                        <br />
                      </Box>
                    </>
                  ) : (
                    ""
                  )}
                  <Divider style={{ marginTop: 20 }} />
                  <Box
                    style={{
                      background: "#E0DEDE",
                      padding: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => (rf ? setRf(false) : setRf(true))}
                  >
                    <b style={{ fontWeight: "bold" }}>
                      {" "}
                      <span
                        class="air_down_icon"
                        id="icon_dept"
                        style={{ fontSize: 14 }}
                      >
                        ▼
                      </span>
                      Fare Type
                    </b>
                  </Box>
                  {rf ? (
                    <>
                      {" "}
                      <Box
                        mt={matches ? "20px" : ""}
                        className={classes.radio}
                        style={{
                          border: "1px solid lightgrey",
                          padding: "10px",
                          transition: "all 0.3s ease-in-out",
                        }}
                      >
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={refund}
                              onChange={handleFareR}
                              name="Refundable"
                            />
                          }
                          label="Refundable"
                        />
                        <br />
                        <FormControlLabel
                          control={
                            <GreenCheckbox
                              checked={nrefund}
                              onChange={handleFareN}
                              name="Non"
                            />
                          }
                          label="Non-Refundable"
                        />
                      </Box>
                    </>
                  ) : (
                    ""
                  )}
                </Box>

                {/* } */}

                {/* <Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box> */}
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <Box
                  justifyContent="space-between"
                  alignItems="center"
                  display="flex"
                >
                  {matches ? (
                    <h3>{`Flights from ${selectedOrigin.city_name} to ${
                      selectedDepart.city_name
                    }(${filterData ? filterData.length : 0})`}</h3>
                  ) : (
                    <h1>{`Flights from ${selectedOrigin.city_name} to ${
                      selectedDepart.city_name
                    }(${filterData ? filterData.length : 0})`}</h1>
                  )}
                  <Hidden only={["sm", "xs"]}>
                    <Box>
                      {agentlogin ? (
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="end"
                        >
                          {/* <h5>Net Fare</h5> */}
                          <FormControlLabel
                            control={
                              <GreenCheckbox
                                checked={net}
                                // onChange={handleNetFare}
                                name="net"
                                style={{ marginLeft: 20 }}
                              />
                            }
                            // label='SpiceJet'
                          />
                        </Box>
                      ) : (
                        ""
                      )}
                      {/* <h4 style={{ marginLeft: 10, margin: 0 }}>
										{`${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											weekday: 'short',
										})} ,  ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).getDate()} ${new Date(
											location.state.body.Segments[0].PreferredDepartureTime
										).toLocaleString('en-us', {
											month: 'short',
										})},2022`}
									</h4> */}
                      {/* <span style={{  margin: 0, marginRight: 5 }}>
											{location.state.body.AdultCount} Adult
										</span>
										<span
											style={{
												marginLeft: 10,
												margin: 0,
												marginRight: 5,
											}}>
											{location.state.body.ChildCount} Child
										</span>
										<span
											style={{
												marginLeft: 10,
												margin: 0,
												marginRight: 5,
											}}>
											{location.state.body.InfantCount} Infant
										</span>
										<span style={{ marginLeft: 10,  margin: 0 }}>
											ECONOMY
										</span> */}
                    </Box>
                  </Hidden>

                  {/* <h6 style={{ margin: 0 }}>
										{filterData.length} Flights Found
									</h6> */}
                </Box>

                {loading ? (
                  [0, 1, 2, 3, 4].map((i) => {
                    return <SkeletonOneway />;
                  })
                ) : rule || (result && result.length > 0) ? (
                  result && result.length > 0 ? (
                    <InfiniteScroll
                      dataLength={scrollValResult}
                      next={fetchMoreDataResult}
                      hasMore={hasMoreresult}
                      loader={<h4>Loading...</h4>}
                      endMessage={
                        <p style={{ textAlign: "center" }}>
                          <b>No More Flights</b>
                        </p>
                      }
                    >
                      {result.map((item, index) => {
                        return index < scrollValResult ? (
                          matches ? (
                            <OneWayMobileRow
                              item={item}
                              loading={loading}
                              timeConvert={timeConvert}
                              location={location}
                              net={net}
                              onewayflightdata={onewayflightdata}
                              onewayflightdataEtrav={onewayflightdataEtrav}
                              convertH2M={convertH2M}
                              index={index}
                            />
                          ) : (
                            <>
                              <OneWayDesktopRow
                                item={item}
                                loading={loading}
                                timeConvert={timeConvert}
                                location={location}
                                onewayflightdata={onewayflightdata}
                                onewayflightdataEtrav={onewayflightdataEtrav}
                                convertH2M={convertH2M}
                                net={net}
                              />
                            </>
                          )
                        ) : (
                          ""
                        );
                      })}
                    </InfiniteScroll>
                  ) : (
                    <div
                      style={{
                        padding: "30px 15px",
                        background: "white",
                        borderBottom: "1px solid #e6e6e6",
                        textAlign: "center",
                      }}
                    >
                      <img src={flightnotfound}></img>
                      <p style={{ fontSize: "24px", textAlign: "center" }}>
                        Sorry No Flight Found !!
                      </p>
                    </div>
                  )
                ) : filterData && filterData.length > 0 ? (
                  <InfiniteScroll
                    dataLength={scrollVal}
                    next={fetchMoreData}
                    hasMore={hasMorefilterData}
                    loader={<h4 style={{ textAlign: "center" }}>Loading...</h4>}
                    endMessage={
                      <p style={{ textAlign: "center" }}>
                        <b>No More Flights</b>
                      </p>
                    }
                  >
                    {filterData.map((item, index) => {
                      return index < scrollVal ? (
                        matches ? (
                          <OneWayMobileRow
                            item={item}
                            loading={loading}
                            timeConvert={timeConvert}
                            location={location}
                            onewayflightdata={onewayflightdata}
                            onewayflightdataEtrav={onewayflightdataEtrav}
                            convertH2M={convertH2M}
                            net={net}
                          />
                        ) : (
                          <OneWayDesktopRow
                            item={item}
                            loading={loading}
                            timeConvert={timeConvert}
                            location={location}
                            onewayflightdata={onewayflightdata}
                            onewayflightdataEtrav={onewayflightdataEtrav}
                            convertH2M={convertH2M}
                            net={net}
                          />
                        )
                      ) : (
                        ""
                      );
                    })}
                  </InfiniteScroll>
                ) : (
                  [0, 1, 2, 3, 4].map((i) => {
                    return <SkeletonOneway />;
                  })
                )}
              </Grid>
            </Grid>
          </Box>
          {/* </Container> */}
        </Box>
      </Box>
      <FlightDetailModal />
      <Drawers />
      <Login />
      {/* <ErrorModal /> */}
    </>
  );
};

export default OneWay;
